import React from "react";

const Title = props => (

  <div className={['flex', 'w-full', 'pst',
  props.mg ? 'mb-0' : 'msb'].join(" ")}>
      <div className={['txtheader', 'leading-none', 'font-light',
  props.mg ? 'mb-0' : 'msb'].join(" ")}>
          {props.title}
      </div>
  </div>

);

export default Title;


// WEBPACK FOOTER //
// ./src/components/TextPage/title.js